export default __webpack_public_path__ + "static/media/economics-round-image.133502c8.png";